

export class DataProvider{
    getData(){}
}